import React from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import ResetPasswordForm from "@hedgefund/shared/src/ResetPasswordForm";
import { alertService } from "@hedgefund/shared/src/Alert";
import { resetPassword } from "./action";

const ResetPassword = () => {
  const history = useHistory();
  const { location } = history;
  const dispatch = useDispatch();

  const resetPasswordState = useSelector((state) => state.resetPassword);
  const { loading } = resetPasswordState;

  const onSuccessAlert = () => {
    alertService.success("Successfully Created!", { autoClose: true });
    setTimeout(() => {
      history.push("/login");
    }, 1000);
  };

  const handleSetNewPassword = (data) => {
    const obj = {
      newPassword: data?.password,
      passwordResetCode: location?.search?.split("=").slice(-1).toString(),
    };
    dispatch(resetPassword(obj, onSuccessAlert));
  };

  return (
    <ResetPasswordForm
      onSubmit={(data) => handleSetNewPassword(data)}
      title="Reset Your Password"
      loading={loading}
    />
  );
};
export default ResetPassword;
